export const CREATE_OFFER_MUTATION = `
  mutation CreateOffer($object: offers_insert_input!) {
    insert_offers_one(object: $object) {
      id
      company_id
      firm_id
      firm_short_name
      firm_established
      proposal_given
      contract_subject_id
      scope_of_work_id
      proposal_date
      proposal_file_key
      proposal_file_size
      revised_proposal_given
      revised_proposals
      proposal_status_id
      comment
      reminder_date
      reminder_note
      sector_id
      created_at
      updated_at
      contract_subject {
        id
        name
      }
      scope_of_work {
        id
        name
      }
      company {
        id
        name
      }
      firm {
        id
        firm_name
        firm_short_name
      }
      proposal_status {
        id
        name
      }
    }
  }
`;

export const UPDATE_OFFER_MUTATION = `
  mutation UpdateOffer($id: Int!, $set: offers_set_input!) {
    update_offers_by_pk(pk_columns: { id: $id }, _set: $set) {
      id
      company_id
      firm_id
      firm_short_name
      firm_established
      proposal_given
      contract_subject_id
      scope_of_work_id
      proposal_date
      proposal_file_key
      proposal_file_size
      revised_proposal_given
      revised_proposals
      proposal_status_id
      comment
      reminder_date
      reminder_note
      sector_id
      created_at
      updated_at
      contract_subject {
        id
        name
      }
      scope_of_work {
        id
        name
      }
      company {
        id
        name
      }
      firm {
        id
        firm_name
        firm_short_name
      }
      proposal_status {
        id
        name
      }
    }
  }
`;

export const DELETE_OFFER_SECTORS_BY_OFFER = `
  mutation DeleteOfferSectorsByOffer($where: offer_sectors_bool_exp!) {
    delete_offer_sectors(where: $where) {
      affected_rows
    }
  }
`;

export const INSERT_OFFER_SECTORS = `
  mutation InsertOfferSectors($objects: [offer_sectors_insert_input!]!) {
    insert_offer_sectors(objects: $objects) {
      affected_rows
    }
  }
`;

export const DELETE_OFFER_MUTATION = `
  mutation DeleteOffer($id: Int!) {
    delete_offers_by_pk(id: $id) {
      id
    }
  }
`; 